import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.auth');
import { OnInit, OnDestroy } from "@angular/core";
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

@Component({
    selector: 'wiz-page-auth',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.auth/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAuthComponent implements OnInit, OnDestroy {

  public type: 'login' | 'join' = 'login';
  private routerSub: Subscription;

  constructor(@Inject( Service)     public service: Service,@Inject( Router  )     private router: Router  ) {}

  async ngOnInit() {
    await this.service.init();

    this.updateType();

    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(async () => {
        this.updateType();
        await this.service.render();
      });

    await this.service.render();
  }

  ngOnDestroy() {
    if (this.routerSub) this.routerSub.unsubscribe();
  }

  private updateType() {
    const url = this.router.url;

    if (url.includes('join')) {
      this.type = 'join';
    } else {
      this.type = 'login';
    }
  }
}

export default PageAuthComponent;